import {
  QueryFunction,
  QueryKey,
  useQuery,
  UseQueryOptions
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { clearStorage } from 'features/auth';
import { UserApiService } from 'features/users';
import { queryClient } from 'providers';
import { PermissionRow } from 'types';
const { getUserRolePermissionList,getRolePrivilegePermissionList } = UserApiService();

const getUserRolePermissionsQuery = (
  id: string,
  options?: UseQueryOptions<PermissionRow[]>,
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<PermissionRow[]>;
  options?: UseQueryOptions<PermissionRow>;
} => ({ 
  queryKey: ["UserRoleManagementList"],
  queryFn: async ({ signal }) => {
    const response = await getUserRolePermissionList(id, { config: { signal } });
      
    if (response.rs === 200 && response.res) {
      return response.res;
    } else {
      clearStorage();
      queryClient.clear();
      throw new Error(`Unexpected response status: ${response.rs}`);
    }
  },
  ...options,
});

export const useGetUserRolePermissions = (id: string, options?: UseQueryOptions<PermissionRow[]>) => {
  const { message } = App.useApp();

  return useQuery<PermissionRow[], Error>(
    getUserRolePermissionsQuery(id, {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      ...options,
    }),
  );
};


const getRolePrivilegePermissionsQuery = (
  id: number,
  options?: UseQueryOptions<PermissionRow[]>,
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<PermissionRow[]>;
  options?: UseQueryOptions<PermissionRow>;
} => ({ 
  queryKey: ["UserRolePrivilegeManagementList",id],
  queryFn: async ({ signal }) => {
    const response = await getRolePrivilegePermissionList(id, { config: { signal } });
      
    if (response.rs === 200 && response.res) {
      return response.res;
    } else {
      clearStorage();
      queryClient.clear();
      throw new Error(`Unexpected response status: ${response.rs}`);
    }
  },
  ...options,
});


export const useGetRolePrivilegePermissions = (id: number, options?: UseQueryOptions<PermissionRow[]>) => {
  const { message } = App.useApp();

  return useQuery<PermissionRow[], Error>(
    getRolePrivilegePermissionsQuery(id, {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      ...options,
    }),
  );
};











